import type { ColDef } from "ag-grid-community";
import { filterParams } from "./utils";

export const publicationColDefs: ColDef[] = [
  {
    field: "title",
    initialSort: "asc",
    comparator: (valueA, valueB) =>
      valueA.toLowerCase().localeCompare(valueB.toLowerCase()),
  },
  { field: "status" },
  {
    field: "lastModified",
    valueFormatter: function (params) {
      return new Date(params.value).toLocaleString("en-UK", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },

    filter: "agDateColumnFilter",
    filterParams,
  },
  { field: "filename", headerName: "Publication Id" },
];
